import { useNavigate } from 'react-router-dom';
import { PageHeader } from '@/components/PageHeader/PageHeader';
import { t } from '@/lib/i18n';
import { useMyGrants } from '../hooks';
import styles from './ConnectorsHubPage.module.css';

const STATUS_LABELS: Record<string, string> = {
  connected: 'Connected',
  not_connected: 'Not set up',
  error: 'Reconnect needed',
};

const CARD_STATUS_CLASS: Record<string, string> = {
  connected: styles.connected ?? '',
  not_connected: styles.notConnected ?? '',
  error: styles.error ?? '',
};

const BADGE_STATUS_CLASS: Record<string, string> = {
  connected: styles.badgeConnected ?? '',
  not_connected: styles.badgeNotConnected ?? '',
  error: styles.badgeError ?? '',
};

export function ConnectorsHubPage() {
  const { data, isLoading } = useMyGrants();
  const navigate = useNavigate();

  if (isLoading) {
    return (
      <div className={styles.page}>
        <p className={styles.loading}>{t('Loading…')}</p>
      </div>
    );
  }

  if (!data?.memberId) {
    return (
      <div className={styles.page}>
        <PageHeader title={t('Connectors')} />
        <div className={styles.empty}>
          <p>{t("You haven't been added as a team Member yet. Ask your Admin.")}</p>
        </div>
      </div>
    );
  }

  if (!data.connectors.length) {
    return (
      <div className={styles.page}>
        <PageHeader title={t('Connectors')} />
        <div className={styles.empty}>
          <p>{t("You haven't been granted access to any connectors yet. Ask your Admin.")}</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.page}>
      <PageHeader
        title={t('Connectors')}
        subtitle={t('Direct access to your connected services.')}
      />
      <div className={styles.grid}>
        {data.connectors.map((c) => (
          <button
            key={c.id}
            className={`${styles.card} ${CARD_STATUS_CLASS[c.connectorStatus] ?? ''}`}
            onClick={() => {
              void navigate(`/connectors/${encodeURIComponent(c.id)}`);
            }}
          >
            <div className={styles.cardName}>{c.name}</div>
            <div className={`${styles.badge} ${BADGE_STATUS_CLASS[c.connectorStatus] ?? ''}`}>
              {STATUS_LABELS[c.connectorStatus]}
            </div>
            <div className={styles.opCount}>
              {c.operations.length} {c.operations.length === 1 ? t('operation') : t('operations')}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
